import Shipment from '../../models/Shipment'

export const ShipmentsModule = {
  namespaced: true,

  state: {
    shipment: new Shipment ( {})
  },

  getters: {
    shipment(state) {
      return state.shipment
    }
  },

  mutations: {
    setShipment(state, shipment) {
      state.shipment = new Shipment(shipment)
    }
  }
}

export default ShipmentsModule